import fetchWithTimeout from './fetchAPI';

export async function getPermissions(token) {
    const headers = new Headers();
    headers.append('token', token);
    const results = await fetchWithTimeout('permission',
        {method: 'GET',
            headers: headers,
            cache: 'no-cache',
            redirect: 'follow',
            credentials: 'omit'
        }, 3000);

    const jsonResults = await results.json();
    return (jsonResults);
}

export async function getBaseRoles(token) {
    const headers = new Headers();
    headers.append('token', token);
    const results = await fetchWithTimeout('baserole',
        {method: 'GET',
            headers: headers,
            cache: 'no-cache',
            redirect: 'follow',
            credentials: 'omit'
        }, 3000);

    const jsonResults = await results.json();
    return (jsonResults);
}

export async function createBaseRole(token, role) {
    const headers = new Headers();
    headers.append('token', token);
    headers.append('Content-Type', 'application/json');
    const results = await fetchWithTimeout('baserole',
        {method: 'POST',
            headers: headers,
            body: JSON.stringify(role),
            cache: 'no-cache',
            redirect: 'follow',
            credentials: 'omit'
        }, 3000);
  
    const jsonResults = await results.json();
    return (jsonResults);
  }
  
export async function updateBaseRole(token, role) {
  const headers = new Headers();
  headers.append('token', token);
  headers.append('Content-Type', 'application/json');
  const results = await fetchWithTimeout('baserole',
      {method: 'PUT',
          headers: headers,
          body: JSON.stringify(role),
          cache: 'no-cache',
          redirect: 'follow',
          credentials: 'omit'
      }, 3000);

  const jsonResults = await results.json();
  return (jsonResults);
}

export async function deleteBaseRole(token, role) {
    const headers = new Headers();
    headers.append('token', token);
    headers.append('Content-Type', 'application/json');
    const results = await fetchWithTimeout('baserole',
        {method: 'DELETE',
            headers: headers,
            body: JSON.stringify(role),
            cache: 'no-cache',
            redirect: 'follow',
            credentials: 'omit'
        }, 3000);
  
    const jsonResults = await results.json();
    return (jsonResults);
}

export async function getRoles(token) {
    const headers = new Headers();
    headers.append('token', token);
    const results = await fetchWithTimeout('role',
        {method: 'GET',
            headers: headers,
            cache: 'no-cache',
            redirect: 'follow',
            credentials: 'omit'
        }, 3000);

    const jsonResults = await results.json();
    return (jsonResults);
}

export async function createRole(token, role) {
    const headers = new Headers();
    headers.append('token', token);
    headers.append('Content-Type', 'application/json');
    const results = await fetchWithTimeout('role',
        {method: 'POST',
            headers: headers,
            body: JSON.stringify(role),
            cache: 'no-cache',
            redirect: 'follow',
            credentials: 'omit'
        }, 3000);
  
    const jsonResults = await results.json();
    return (jsonResults);
  }
  
export async function updateRole(token, role) {
  const headers = new Headers();
  headers.append('token', token);
  headers.append('Content-Type', 'application/json');
  const results = await fetchWithTimeout('role',
      {method: 'PUT',
          headers: headers,
          body: JSON.stringify(role),
          cache: 'no-cache',
          redirect: 'follow',
          credentials: 'omit'
      }, 3000);

  const jsonResults = await results.json();
  return (jsonResults);
}

export async function deleteRole(token, role) {
    const headers = new Headers();
    headers.append('token', token);
    headers.append('Content-Type', 'application/json');
    const results = await fetchWithTimeout('role',
        {method: 'DELETE',
            headers: headers,
            body: JSON.stringify(role),
            cache: 'no-cache',
            redirect: 'follow',
            credentials: 'omit'
        }, 3000);
  
    const jsonResults = await results.json();
    return (jsonResults);
}
